import React from 'react';
import useAuth from '../hooks/utils/useAuth';
import { ArrowButton } from '../assets/images/svgs';

export const LoginButton: React.FC = () => {
  const { keycloak, redirectTo } = useAuth();

  return (
    <div className="flex items-center justify-center gap-1">
      <p className="text-xs leading-5">
        <span className="font-albert-sans font-normal text-black">Already have an account?</span>
        <span className="font-albert-sans font-normal"> </span>
        <button
          data-testid="login-button"
          className="font-albert-sans text-primary m-0 cursor-pointer border-0 bg-transparent p-0 font-medium hover:underline"
          onClick={() =>
            keycloak?.login({
              redirectUri: `${window.location.origin}${redirectTo}`,
            })
          }
        >
          Log in
        </button>
      </p>
      <div className="flex items-center">
        <ArrowButton backgroundColor="rgb(var(--color-button-secondary))" direction="right" className="h-5 w-5" />
      </div>
    </div>
  );
};
